// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PANzVW4HVJ0wBBn5 .p-multiselect-label {
  flex-wrap: wrap;
  display: flex;
  row-gap: 5px;
}

.JBTgxDIekVIFLYsr {
  min-height: calc(100vh - 97px);
  padding: 44px 0px 176px;
  background-color: #f3f5f7;
}

.tL9u_beGQ8wayCc6 {
  width: 996px;
  margin: 0 auto;
  border-radius: 51px;
  overflow: hidden;
  background-color: #f2efea;
}

.N3GbTX5FE0khxk6b {
  height: 328px;
  background-color: gray;
  background-size: cover;
  background-position: center;
  position: relative;
}

.YJ4GQ7x4wio2_OWB {
  position: absolute;
  top: 28px;
  left: 55px;
  background-color: #ffffff;
  border-radius: 50%;
  width: 53px;
  height: 53px;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
}

.YJ4GQ7x4wio2_OWB i {
  font-size: 28px;
  margin-right: 3px;
}

.OsVRUGUimw3ORf2V {
  position: absolute;
  top: 36px;
  right: 55px;
  font-size: 16px;
  font-family: "Roboto";
  padding: 10px 21px;
  background-color: #c84014;
  border-radius: 16px;
  color: #ffffff;
  border: 1px solid #ffffff;
}

.Mmv8u5csVucghWMc {
  padding: 40px 70px 132px;
}

.cwfJ1JW8o88ZBXNT {
  text-align: center;
  font-weight: 200;
  font-style: italic;
  margin-top: 0px;
  margin-bottom: 42px;
  font-size: 16px;
}

.tL9u_beGQ8wayCc6 h1 {
  padding: 0px;
  margin: 0px;
  text-align: center;
  font-family: "Roboto";
  font-size: 36px;
  font-weight: 900;
  text-transform: uppercase;
  margin-bottom: 56px;
}

.JlrWx7yUU8wq3Y_4 {
  display: flex;
  gap: 19px;
}

.ufuhBG5MFMIudgtx {
  font-family: "Roboto";
  font-weight: bold;
  font-size: 24px;
  color: #000000;
  margin-bottom: 17px;
}

.yRi_9_qZTcQIUOra {
  font-size: 16px !important;
}

.AYkF3wGG2kcYoqip {
  margin-bottom: 52px;
  width: 100%;
}

.BdXSxDeNcD8PSXSe {
  padding: 22px 32px 24px;
  border-radius: 24px;
  font-size: 21px !important;
  height: 66px;
  font-family: "Roboto";
}

.SrHNdS5p9XMO0ofG {
  border-radius: 24px 0 0 24px;
  padding: 16px 6px 22px 32px;
  height: 66px;
  font-size: 21px !important;
  display: inline-block;
  -webkit-text-size-adjust: 100%;
}

.ZPOMHhGPllsw0xAB {
  border-radius: 0 24px 24px 0;
  padding-left: 4px;
}

.MX_OoEtgh4ci4lL5 {
  display: flex;
  align-items: center;
}

.MX_OoEtgh4ci4lL5 div {
  width: 80px;
  height: 80px;
  background-size: cover;
  background-color: #eeeeee;
  margin-right: 10px;
  border-radius: 6px;
}

.sd6RzYzKM1YKlGq3 {
  margin-bottom: 52px;
}

.sd6RzYzKM1YKlGq3 .p-dropdown {
  width: 100%;
  height: 66px;
  border-radius: 24px;
}

.sd6RzYzKM1YKlGq3 .p-dropdown-label {
  display: block;
  padding: 17px 32px 24px;
  font-size: 21px;
  font-family: "Roboto";
}

.DZgtjmACLoDNIJrV {
  border-radius: 24px;
  border: 1px solid #a4a4a4;
  overflow: hidden;
  padding: 16px 34px;
}

.DZgtjmACLoDNIJrV .p-dropdown-items-wrapper {
  max-height: 400px !important;
}

.DZgtjmACLoDNIJrV .p-dropdown-items li {
  height: 88px;
  border-radius: 6px;
  margin: 4px 0px;
  padding: 4px;
}

.TuNqL2qPYPkRVcSo.DZgtjmACLoDNIJrV .p-dropdown-items li {
  height: 57px;
  border-radius: 15px;
  margin: 4px 0px;
  padding: 21px 15px;
}

.DZgtjmACLoDNIJrV .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  border: 2px solid transparent;
}

.DZgtjmACLoDNIJrV
  .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  border: 2px solid #20336c;
  background-color: inherit;
}

.DZgtjmACLoDNIJrV .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  background-color: inherit;
}

.DZgtjmACLoDNIJrV .p-dropdown-item.p-highlight {
  color: #ffffff;
  background-color: #20336c;
}

.DZgtjmACLoDNIJrV .p-dropdown-item.p-highlight:after {
  content: "✓";
  position: absolute;
  right: 16px;
  font-size: 24px;
  color: #ffffff;
}

.q9hdE87yiwYG4eGm {
  margin-bottom: 52px;
}

.q9hdE87yiwYG4eGm .p-multiselect {
  width: 100%;
  border-radius: 24px;
}

.q9hdE87yiwYG4eGm .p-multiselect-token {
  background-color: #20336c15;
  border-radius: 100px;
}

.q9hdE87yiwYG4eGm .p-multiselect-label {
  padding: 17px 32px 24px;
  font-size: 21px;
  font-family: "Roboto";
}

.nMYOrXHYuooXdSHx {
  border-radius: 24px;
  border: 1px solid #a4a4a4;
  overflow: hidden;
  padding: 16px 34px;
}

.nMYOrXHYuooXdSHx .p-multiselect-items-wrapper {
  max-height: 400px !important;
}

.nMYOrXHYuooXdSHx .p-multiselect-header {
  display: none;
}

.nMYOrXHYuooXdSHx .p-multiselect-items li {
  height: 88px;
  border-radius: 6px;
  margin: 4px 0px;
  padding: 4px;
}

.TuNqL2qPYPkRVcSo.nMYOrXHYuooXdSHx .p-multiselect-items li {
  height: 57px;
  border-radius: 15px;
  margin: 4px 0px;
  padding: 21px 15px;
}

.nMYOrXHYuooXdSHx
  .p-multiselect-item:not(.p-highlight):not(.p-disabled) {
  border: 2px solid transparent;
}

.nMYOrXHYuooXdSHx
  .p-multiselect-item:not(.p-highlight):not(.p-disabled).p-focus {
  border: 2px solid #20336c;
  background-color: inherit;
}

.nMYOrXHYuooXdSHx
  .p-multiselect-item:not(.p-highlight):not(.p-disabled) {
  background-color: inherit;
}

.nMYOrXHYuooXdSHx .p-multiselect-item.p-highlight {
  color: #ffffff;
  background-color: #20336c;
}

.nMYOrXHYuooXdSHx .p-multiselect-item.p-highlight:after {
  content: "✓";
  position: absolute;
  right: 16px;
  font-size: 24px;
  color: #ffffff;
}

.nMYOrXHYuooXdSHx .p-multiselect-checkbox {
  display: none;
}

.KUsFd3mFxQJyBmmA {
  resize: none;
  border-radius: 24px;
  height: 132px;
  padding: 15px;
  /*margin-bottom: 52px;*/
}

.m_Er61kOZhUb2byc {
  color: #F44336;
  margin-left: 15px;
}

.kY5YlSlbwAxwjdF5 {
  border-radius: 24px;
  background-color: #20336c;
  font-family: "Roboto";
  font-weight: 900;
  font-size: 30px;
  text-transform: uppercase;
  width: 100%;
  padding: 24px;
}

.RwpU3KOu0YsYV4nJ {
  text-align: center;
  font-size: 20px;
}

.Wl6IEFtVZH4ro7jU {
  margin-top: 5px;
  padding-left: 5px;
  font-size: 14px;
}

.tpLYqCNVtN4VEN5d {
  margin-left: 4px;
  text-decoration: underline;
  color: #20336c;
}

@media screen and (max-width: 1024px) {
  .JBTgxDIekVIFLYsr {
    min-height: auto;
    padding: 0px;
  }

  .tL9u_beGQ8wayCc6 {
    width: 100%;
    border: none;
    box-shadow: none;
    border-radius: 0px;
    padding-bottom: 108px;
  }

  .N3GbTX5FE0khxk6b {
    height: 204px;
  }

  .YJ4GQ7x4wio2_OWB {
    top: 20px;
    left: 30px;
    border-radius: 50%;
    width: 34px;
    height: 34px;
    outline: none;
    border: none;
  }

  .YJ4GQ7x4wio2_OWB i {
    font-size: 24px;
    margin-right: 2px;
  }

  .OsVRUGUimw3ORf2V {
    top: 27px;
    right: 30px;
    font-size: 10px;
    padding: 6px 6px;
  }

  .Mmv8u5csVucghWMc {
    padding: 25px 25px 85px;
    padding-bottom: 0px;
  }

  .cwfJ1JW8o88ZBXNT {
    margin-top: 0px;
    margin-bottom: 25px;
    font-size: 12px;
  }

  .tL9u_beGQ8wayCc6 h1 {
    padding: 0px;
    margin: 0px;
    text-align: center;
    font-family: "Roboto";
    font-size: 20px;
    font-weight: 900;
    margin-bottom: 40px;
  }

  .JlrWx7yUU8wq3Y_4 {
    flex-direction: column;
    gap: 6px;
    margin-bottom: 38px;
  }

  .JlrWx7yUU8wq3Y_4 .AYkF3wGG2kcYoqip,
  .JlrWx7yUU8wq3Y_4 .BdXSxDeNcD8PSXSe {
    margin: 0px;
  }

  .ufuhBG5MFMIudgtx {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 12px;
  }

  .BdXSxDeNcD8PSXSe {
    padding: 17px 22px;
    border-radius: 16px;
    font-size: 14px;
    height: 44px;
    margin-bottom: 38px;
  }

  .SrHNdS5p9XMO0ofG {
    padding: 11px 6px 22px 32px;
    height: 44px;
    font-size: 14px;
  }

  .ZPOMHhGPllsw0xAB {
    border-radius: 0 24px 24px 0;
    padding-left: 4px;
    margin: 0px;
  }

  .SEo2PfJBd8IXu5oD {
    margin: 0;
    margin-top: 14px;
    font-size: 10px;
  }

  .MX_OoEtgh4ci4lL5 div {
    width: 54px;
    height: 54px;
    margin-right: 18px;
    border-radius: 4px;
  }

  .sd6RzYzKM1YKlGq3 {
    margin-bottom: 38px;
  }

  .sd6RzYzKM1YKlGq3 .p-dropdown {
    height: 44px;
    border-radius: 16px;
  }

  .sd6RzYzKM1YKlGq3 .p-dropdown-label {
    padding: 13px 22px;
    font-size: 14px;
  }

  .DZgtjmACLoDNIJrV {
    border-radius: 16px;
    padding: 18px 11px;
  }

  .DZgtjmACLoDNIJrV .p-dropdown-items-wrapper {
    max-height: 270px !important;
  }

  .DZgtjmACLoDNIJrV .p-dropdown-items {
    margin: 0px;
    padding: 0px;
  }

  .DZgtjmACLoDNIJrV .p-dropdown-items li {
    height: 60px;
    border-radius: 4px;
    margin: 2px 0px;
  }

  .TuNqL2qPYPkRVcSo.DZgtjmACLoDNIJrV .p-dropdown-items li {
    height: 38px;
    border-radius: 10px;
    padding: 14px 11px;
    font-size: 14px;
    margin: 2px 0px;
  }

  .DZgtjmACLoDNIJrV .p-dropdown-item.p-highlight:after {
    font-size: 14px;
  }

  .q9hdE87yiwYG4eGm {
    margin-bottom: 38px;
  }

  .q9hdE87yiwYG4eGm .p-multiselect {
    border-radius: 16px;
  }

  .q9hdE87yiwYG4eGm .p-multiselect-label {
    padding: 13px 22px;
    font-size: 14px;
  }

  .nMYOrXHYuooXdSHx {
    border-radius: 16px;
    padding: 18px 11px;
  }

  .nMYOrXHYuooXdSHx .p-multiselect-items-wrapper {
    max-height: 270px !important;
  }

  .nMYOrXHYuooXdSHx .p-multiselect-items {
    margin: 0px;
    padding: 0px;
  }

  .nMYOrXHYuooXdSHx .p-multiselect-items li {
    height: 60px;
    border-radius: 4px;
    margin: 2px 0px;
  }

  .TuNqL2qPYPkRVcSo.nMYOrXHYuooXdSHx .p-multiselect-items li {
    height: 38px;
    border-radius: 10px;
    margin: 2px 0px;
    padding: 14px 11px;
  }

  .nMYOrXHYuooXdSHx .p-multiselect-item.p-highlight:after {
    font-size: 14px;
  }

  .KUsFd3mFxQJyBmmA {
    border-radius: 16px;
    height: 88px;
    padding: 12px;
    margin-bottom: 38px;
  }

  .kY5YlSlbwAxwjdF5 {
    border-radius: 16px;
    font-size: 16px;
    padding: 17px;
  }

  .RwpU3KOu0YsYV4nJ {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/OrderPage.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,0BAA0B;EAC1B,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".multiSelect :global(.p-multiselect-label) {\r\n  flex-wrap: wrap;\r\n  display: flex;\r\n  row-gap: 5px;\r\n}\r\n\r\n.pageWrapper {\r\n  min-height: calc(100vh - 97px);\r\n  padding: 44px 0px 176px;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.orderCard {\r\n  width: 996px;\r\n  margin: 0 auto;\r\n  border-radius: 51px;\r\n  overflow: hidden;\r\n  background-color: #f2efea;\r\n}\r\n\r\n.stationImage {\r\n  height: 328px;\r\n  background-color: gray;\r\n  background-size: cover;\r\n  background-position: center;\r\n  position: relative;\r\n}\r\n\r\n.backButton {\r\n  position: absolute;\r\n  top: 28px;\r\n  left: 55px;\r\n  background-color: #ffffff;\r\n  border-radius: 50%;\r\n  width: 53px;\r\n  height: 53px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  outline: none;\r\n  border: none;\r\n}\r\n\r\n.backButton i {\r\n  font-size: 28px;\r\n  margin-right: 3px;\r\n}\r\n\r\n.estimatedTime {\r\n  position: absolute;\r\n  top: 36px;\r\n  right: 55px;\r\n  font-size: 16px;\r\n  font-family: \"Roboto\";\r\n  padding: 10px 21px;\r\n  background-color: #c84014;\r\n  border-radius: 16px;\r\n  color: #ffffff;\r\n  border: 1px solid #ffffff;\r\n}\r\n\r\n.formWrapper {\r\n  padding: 40px 70px 132px;\r\n}\r\n\r\n.orderRestrictions {\r\n  text-align: center;\r\n  font-weight: 200;\r\n  font-style: italic;\r\n  margin-top: 0px;\r\n  margin-bottom: 42px;\r\n  font-size: 16px;\r\n}\r\n\r\n.orderCard h1 {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  text-align: center;\r\n  font-family: \"Roboto\";\r\n  font-size: 36px;\r\n  font-weight: 900;\r\n  text-transform: uppercase;\r\n  margin-bottom: 56px;\r\n}\r\n\r\n.nameWrapper {\r\n  display: flex;\r\n  gap: 19px;\r\n}\r\n\r\n.label {\r\n  font-family: \"Roboto\";\r\n  font-weight: bold;\r\n  font-size: 24px;\r\n  color: #000000;\r\n  margin-bottom: 17px;\r\n}\r\n\r\n.maxOptionsLabel {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.inputWrapper {\r\n  margin-bottom: 52px;\r\n  width: 100%;\r\n}\r\n\r\n.input {\r\n  padding: 22px 32px 24px;\r\n  border-radius: 24px;\r\n  font-size: 21px !important;\r\n  height: 66px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.phonePrefix {\r\n  border-radius: 24px 0 0 24px;\r\n  padding: 16px 6px 22px 32px;\r\n  height: 66px;\r\n  font-size: 21px !important;\r\n  display: inline-block;\r\n  -webkit-text-size-adjust: 100%;\r\n}\r\n\r\n.phoneInput {\r\n  border-radius: 0 24px 24px 0;\r\n  padding-left: 4px;\r\n}\r\n\r\n.listItem {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.listItem div {\r\n  width: 80px;\r\n  height: 80px;\r\n  background-size: cover;\r\n  background-color: #eeeeee;\r\n  margin-right: 10px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.dropDownWrapper {\r\n  margin-bottom: 52px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown) {\r\n  width: 100%;\r\n  height: 66px;\r\n  border-radius: 24px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-label) {\r\n  display: block;\r\n  padding: 17px 32px 24px;\r\n  font-size: 21px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.dropDownPanel {\r\n  border-radius: 24px;\r\n  border: 1px solid #a4a4a4;\r\n  overflow: hidden;\r\n  padding: 16px 34px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items-wrapper) {\r\n  max-height: 400px !important;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items) li {\r\n  height: 88px;\r\n  border-radius: 6px;\r\n  margin: 4px 0px;\r\n  padding: 4px;\r\n}\r\n\r\n.withOutImage.dropDownPanel :global(.p-dropdown-items) li {\r\n  height: 57px;\r\n  border-radius: 15px;\r\n  margin: 4px 0px;\r\n  padding: 21px 15px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.dropDownPanel\r\n  :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus) {\r\n  border: 2px solid #20336c;\r\n  background-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  background-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight) {\r\n  color: #ffffff;\r\n  background-color: #20336c;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight:after) {\r\n  content: \"✓\";\r\n  position: absolute;\r\n  right: 16px;\r\n  font-size: 24px;\r\n  color: #ffffff;\r\n}\r\n\r\n.multiSelectWrapper {\r\n  margin-bottom: 52px;\r\n}\r\n\r\n.multiSelectWrapper :global(.p-multiselect) {\r\n  width: 100%;\r\n  border-radius: 24px;\r\n}\r\n\r\n.multiSelectWrapper :global(.p-multiselect-token) {\r\n  background-color: #20336c15;\r\n  border-radius: 100px;\r\n}\r\n\r\n.multiSelectWrapper :global(.p-multiselect-label) {\r\n  padding: 17px 32px 24px;\r\n  font-size: 21px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.multiSelectPanel {\r\n  border-radius: 24px;\r\n  border: 1px solid #a4a4a4;\r\n  overflow: hidden;\r\n  padding: 16px 34px;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-items-wrapper) {\r\n  max-height: 400px !important;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-header) {\r\n  display: none;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-items) li {\r\n  height: 88px;\r\n  border-radius: 6px;\r\n  margin: 4px 0px;\r\n  padding: 4px;\r\n}\r\n\r\n.withOutImage.multiSelectPanel :global(.p-multiselect-items) li {\r\n  height: 57px;\r\n  border-radius: 15px;\r\n  margin: 4px 0px;\r\n  padding: 21px 15px;\r\n}\r\n\r\n.multiSelectPanel\r\n  :global(.p-multiselect-item:not(.p-highlight):not(.p-disabled)) {\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.multiSelectPanel\r\n  :global(.p-multiselect-item:not(.p-highlight):not(.p-disabled).p-focus) {\r\n  border: 2px solid #20336c;\r\n  background-color: inherit;\r\n}\r\n\r\n.multiSelectPanel\r\n  :global(.p-multiselect-item:not(.p-highlight):not(.p-disabled)) {\r\n  background-color: inherit;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-item.p-highlight) {\r\n  color: #ffffff;\r\n  background-color: #20336c;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-item.p-highlight:after) {\r\n  content: \"✓\";\r\n  position: absolute;\r\n  right: 16px;\r\n  font-size: 24px;\r\n  color: #ffffff;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-checkbox) {\r\n  display: none;\r\n}\r\n\r\n.textArea {\r\n  resize: none;\r\n  border-radius: 24px;\r\n  height: 132px;\r\n  padding: 15px;\r\n  /*margin-bottom: 52px;*/\r\n}\r\n\r\n.error {\r\n  color: #F44336;\r\n  margin-left: 15px;\r\n}\r\n\r\n.submitButton {\r\n  border-radius: 24px;\r\n  background-color: #20336c;\r\n  font-family: \"Roboto\";\r\n  font-weight: 900;\r\n  font-size: 30px;\r\n  text-transform: uppercase;\r\n  width: 100%;\r\n  padding: 24px;\r\n}\r\n\r\n.orderCreated {\r\n  text-align: center;\r\n  font-size: 20px;\r\n}\r\n\r\n.pushMobileInfoText {\r\n  margin-top: 5px;\r\n  padding-left: 5px;\r\n  font-size: 14px;\r\n}\r\n\r\n.installLink {\r\n  margin-left: 4px;\r\n  text-decoration: underline;\r\n  color: #20336c;\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .pageWrapper {\r\n    min-height: auto;\r\n    padding: 0px;\r\n  }\r\n\r\n  .orderCard {\r\n    width: 100%;\r\n    border: none;\r\n    box-shadow: none;\r\n    border-radius: 0px;\r\n    padding-bottom: 108px;\r\n  }\r\n\r\n  .stationImage {\r\n    height: 204px;\r\n  }\r\n\r\n  .backButton {\r\n    top: 20px;\r\n    left: 30px;\r\n    border-radius: 50%;\r\n    width: 34px;\r\n    height: 34px;\r\n    outline: none;\r\n    border: none;\r\n  }\r\n\r\n  .backButton i {\r\n    font-size: 24px;\r\n    margin-right: 2px;\r\n  }\r\n\r\n  .estimatedTime {\r\n    top: 27px;\r\n    right: 30px;\r\n    font-size: 10px;\r\n    padding: 6px 6px;\r\n  }\r\n\r\n  .formWrapper {\r\n    padding: 25px 25px 85px;\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .orderRestrictions {\r\n    margin-top: 0px;\r\n    margin-bottom: 25px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .orderCard h1 {\r\n    padding: 0px;\r\n    margin: 0px;\r\n    text-align: center;\r\n    font-family: \"Roboto\";\r\n    font-size: 20px;\r\n    font-weight: 900;\r\n    margin-bottom: 40px;\r\n  }\r\n\r\n  .nameWrapper {\r\n    flex-direction: column;\r\n    gap: 6px;\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .nameWrapper .inputWrapper,\r\n  .nameWrapper .input {\r\n    margin: 0px;\r\n  }\r\n\r\n  .label {\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .input {\r\n    padding: 17px 22px;\r\n    border-radius: 16px;\r\n    font-size: 14px;\r\n    height: 44px;\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .phonePrefix {\r\n    padding: 11px 6px 22px 32px;\r\n    height: 44px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .phoneInput {\r\n    border-radius: 0 24px 24px 0;\r\n    padding-left: 4px;\r\n    margin: 0px;\r\n  }\r\n\r\n  .phoneNote {\r\n    margin: 0;\r\n    margin-top: 14px;\r\n    font-size: 10px;\r\n  }\r\n\r\n  .listItem div {\r\n    width: 54px;\r\n    height: 54px;\r\n    margin-right: 18px;\r\n    border-radius: 4px;\r\n  }\r\n\r\n  .dropDownWrapper {\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .dropDownWrapper :global(.p-dropdown) {\r\n    height: 44px;\r\n    border-radius: 16px;\r\n  }\r\n\r\n  .dropDownWrapper :global(.p-dropdown-label) {\r\n    padding: 13px 22px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .dropDownPanel {\r\n    border-radius: 16px;\r\n    padding: 18px 11px;\r\n  }\r\n\r\n  .dropDownPanel :global(.p-dropdown-items-wrapper) {\r\n    max-height: 270px !important;\r\n  }\r\n\r\n  .dropDownPanel :global(.p-dropdown-items) {\r\n    margin: 0px;\r\n    padding: 0px;\r\n  }\r\n\r\n  .dropDownPanel :global(.p-dropdown-items) li {\r\n    height: 60px;\r\n    border-radius: 4px;\r\n    margin: 2px 0px;\r\n  }\r\n\r\n  .withOutImage.dropDownPanel :global(.p-dropdown-items) li {\r\n    height: 38px;\r\n    border-radius: 10px;\r\n    padding: 14px 11px;\r\n    font-size: 14px;\r\n    margin: 2px 0px;\r\n  }\r\n\r\n  .dropDownPanel :global(.p-dropdown-item.p-highlight:after) {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .multiSelectWrapper {\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .multiSelectWrapper :global(.p-multiselect) {\r\n    border-radius: 16px;\r\n  }\r\n\r\n  .multiSelectWrapper :global(.p-multiselect-label) {\r\n    padding: 13px 22px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .multiSelectPanel {\r\n    border-radius: 16px;\r\n    padding: 18px 11px;\r\n  }\r\n\r\n  .multiSelectPanel :global(.p-multiselect-items-wrapper) {\r\n    max-height: 270px !important;\r\n  }\r\n\r\n  .multiSelectPanel :global(.p-multiselect-items) {\r\n    margin: 0px;\r\n    padding: 0px;\r\n  }\r\n\r\n  .multiSelectPanel :global(.p-multiselect-items) li {\r\n    height: 60px;\r\n    border-radius: 4px;\r\n    margin: 2px 0px;\r\n  }\r\n\r\n  .withOutImage.multiSelectPanel :global(.p-multiselect-items) li {\r\n    height: 38px;\r\n    border-radius: 10px;\r\n    margin: 2px 0px;\r\n    padding: 14px 11px;\r\n  }\r\n\r\n  .multiSelectPanel :global(.p-multiselect-item.p-highlight:after) {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .textArea {\r\n    border-radius: 16px;\r\n    height: 88px;\r\n    padding: 12px;\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .submitButton {\r\n    border-radius: 16px;\r\n    font-size: 16px;\r\n    padding: 17px;\r\n  }\r\n\r\n  .orderCreated {\r\n    font-size: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var multiSelect = `PANzVW4HVJ0wBBn5`;
export var pageWrapper = `JBTgxDIekVIFLYsr`;
export var orderCard = `tL9u_beGQ8wayCc6`;
export var stationImage = `N3GbTX5FE0khxk6b`;
export var backButton = `YJ4GQ7x4wio2_OWB`;
export var estimatedTime = `OsVRUGUimw3ORf2V`;
export var formWrapper = `Mmv8u5csVucghWMc`;
export var orderRestrictions = `cwfJ1JW8o88ZBXNT`;
export var nameWrapper = `JlrWx7yUU8wq3Y_4`;
export var label = `ufuhBG5MFMIudgtx`;
export var maxOptionsLabel = `yRi_9_qZTcQIUOra`;
export var inputWrapper = `AYkF3wGG2kcYoqip`;
export var input = `BdXSxDeNcD8PSXSe`;
export var phonePrefix = `SrHNdS5p9XMO0ofG`;
export var phoneInput = `ZPOMHhGPllsw0xAB`;
export var listItem = `MX_OoEtgh4ci4lL5`;
export var dropDownWrapper = `sd6RzYzKM1YKlGq3`;
export var dropDownPanel = `DZgtjmACLoDNIJrV`;
export var withOutImage = `TuNqL2qPYPkRVcSo`;
export var multiSelectWrapper = `q9hdE87yiwYG4eGm`;
export var multiSelectPanel = `nMYOrXHYuooXdSHx`;
export var textArea = `KUsFd3mFxQJyBmmA`;
export var error = `m_Er61kOZhUb2byc`;
export var submitButton = `kY5YlSlbwAxwjdF5`;
export var orderCreated = `RwpU3KOu0YsYV4nJ`;
export var pushMobileInfoText = `Wl6IEFtVZH4ro7jU`;
export var installLink = `tpLYqCNVtN4VEN5d`;
export var phoneNote = `SEo2PfJBd8IXu5oD`;
export default ___CSS_LOADER_EXPORT___;
